import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { PaymentMethodModel } from '@data-layer/models/payments';
import { ACH_STRIPE_CONST, ALIPAY_BLUESNAP_CONST, BANKTRANSFER_BLUESNAP_CONST, ECP_BLUESNAP_CONST } from '@app/modules/payment/const';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { enumPaymentMethodCodeId } from '@app/data-layer/enums/payments';

@Component({
  selector: 'app-payment-methods-item',
  templateUrl: './payment-methods-item.component.html',
  styleUrls: ['./payment-methods-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentMethodsItemComponent implements OnInit, OnDestroy {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public paymentMethod: PaymentMethodModel;
  @Input() public isShowFee: boolean;
  @Input() public isSkipHints: boolean;
  @Input() public id: string = 'paymentMethod';

  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(private cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.formGroup
      .get('paymentMethod')
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(() => this.cdr.markForCheck());
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  public isShowHint(providerPaymentCode: string, codeId: number): boolean {
    const isCodeIdIncluded = [enumPaymentMethodCodeId.BANK_TRANSFER].includes(codeId);
    if (isCodeIdIncluded) {
      return isCodeIdIncluded;
    }

    if (!providerPaymentCode) {
      return;
    }

    return [ECP_BLUESNAP_CONST, BANKTRANSFER_BLUESNAP_CONST, ALIPAY_BLUESNAP_CONST, ACH_STRIPE_CONST].includes(
      providerPaymentCode.toLowerCase(),
    );
  }

  public hintText(providerPaymentCode: string, codeId: number): string {
    switch (codeId) {
      case enumPaymentMethodCodeId.BANK_TRANSFER:
        return 'BANK_TRANSFER_METHOD.PAYMENT_COMPILATION_PROCESS';
    }

    if (!providerPaymentCode) {
      return;
    }

    switch (providerPaymentCode.toLowerCase()) {
      case ECP_BLUESNAP_CONST:
      case ACH_STRIPE_CONST:
        return 'ACH_METHOD_HINT';
      case BANKTRANSFER_BLUESNAP_CONST:
        return 'BANK_TRANSFER_METHOD.PAYMENT_PROCESS_UNDER_SENDER';
      case ALIPAY_BLUESNAP_CONST:
        return 'ALIPAY_METHOD_HINT';
    }
  }

  public get allFees(): string {
    if (!this.paymentMethod.feePercentage && !this.paymentMethod.feeConstant) {
      return;
    }

    return `${!!this.paymentMethod.feePercentage ? this.paymentMethod.feePercentage + '%' : ''} ${
      !!this.paymentMethod.feeConstant ? (!!this.paymentMethod.feePercentage ? ', ' : '') + this.paymentMethod.feeConstant + '$' : ''
    }`;
  }
}
